import { render, staticRenderFns } from "./WidgetPassageReference.vue?vue&type=template&id=7656cb1d&"
import script from "./WidgetPassageReference.vue?vue&type=script&lang=js&"
export * from "./WidgetPassageReference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WidgetPassageReference.vue"
export default component.exports